<!--
  --
  -- 予約確認カード
  --
  -->
<template>
  <v-card
    class="text--primary"
  >
    <!-- メッセージ -->
    <v-card-text>
      <p class="mb-0">
        <template v-if="isNewBook">
          次の予約内容に間違いがなければ、<kbd>予約する</kbd> を押してください。
        </template>
        <template v-else>
          変更内容をご確認ください。
        </template>
      </p>
    </v-card-text>

    <c-card-errors :errors="errors" />

    <!-- アクション -->
    <v-card-actions>
      <v-spacer/>

      <v-btn
        v-if="isNewBook"
        color="primary"
        :loading="running"
        :disabled="running"
        @click="onRegister"
      >
        <span>予約する</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CCardErrors from '@/components/CCardErrors'

import { run } from '@/libs/a'

export default {
  name: 'CConfirmCard',
  components: {
    CCardErrors
  },

  data: () => ({
    // 予約エラー内容
    errors: [],

    // 処理中
    running: false
  }),

  computed: {
    isNewBook () {
      return this.getters['book/reserveID'] === 0
    }
  },

  methods: {
    onRegister () {
      run(async () => {
        this.errors = []

        // 予約を登録する
        this.running = true
        const result = await this.dispatch('book/register')
        this.running = false

        // エラーがあれば表示する
        if (!result.ok) {
          this.errors = result.reasons
          alert(result.reasons)
          return
        }

        // 予約完了ページへ
        this.goTo({ name: 'book/completed' })
      })
    }
  }
}
</script>
